<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { colors, getColorForId } from '~/utils/colors'
import { useContentHelper } from '~/composables/useContentHelper'
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
import StackedCard from '~/components/cards/StackedCard.vue'
import SearchCard from '~/components/cards/SearchCard.vue'

defineProps<{
  results: BaseItem[]
  isLoading: boolean
}>()

const { isPackage, isProduct } = useContentHelper()

const isPackageCard = (resource: BaseItem) => isPackage(resource) || isProduct(resource)
</script>

<template>
  <AuSkeletonWrapper
    v-if="isLoading"
    class="xs:grid-cols-2 grid grid-cols-1 gap-6"
  >
    <AuSkeleton
      v-for="i in 16"
      :key="i"
      height="160px"
    />
  </AuSkeletonWrapper>
  <ul
    v-else
    class="xs:grid-cols-2 grid grid-cols-1 gap-4"
  >
    <li
      v-for="result in results"
      :key="`resource-${result.locationId}`"
      :class="isPackageCard(result) && result.thumbnail ? 'row-span-2' : 'row-span-1'"
    >
      <StackedCard
        v-if="isPackageCard(result)"
        class="size-full"
        :item="result"
        :color="getColorForId(result.locationId, colors)"
        padded-stack
      >
        <template #default="{ item }">
          <SearchCard
            v-if="item"
            :item="item"
            package-style
          />
        </template>
      </StackedCard>
      <SearchCard
        v-else
        :item="result"
      />
    </li>
  </ul>
</template>
